/**
 * Hierarchical Navigation Accordion
 * Handles the accordion functionality for the hierarchical navigation component
 */
export default class HierarchicalNav {
    constructor() {
        this.nav = document.querySelector('.hierarchical-navigation');

        if (!this.nav) {
            return;
        }

        this.init();
    }

    init() {
        // Mobile toggle functionality
        $('[data-hierarchical-navigation-mobile-trigger]').on('click', function() {
            $('.hierarchical-navigation__list--level-0').toggle();
        });

        // Add collapsed class management for accordion items
        $('.hierarchical-navigation .collapse').on('show.bs.collapse', function (e) {
            // Stop event from bubbling to parent collapse elements
            e.stopPropagation();

            // Find the direct parent list item (not ancestors)
            let $listItem = $(this).parent('.hierarchical-navigation__list-item');
            let $toggle = $listItem.children('.hierarchical-navigation__item-wrapper').find('.hierarchical-navigation__toggle');

            $toggle.attr('aria-expanded', 'true');
            $listItem.addClass('expanded');
        });

        $('.hierarchical-navigation .collapse').on('hide.bs.collapse', function (e) {
            // Stop event from bubbling to parent collapse elements
            e.stopPropagation();

            // Find the direct parent list item (not ancestors)
            let $listItem = $(this).parent('.hierarchical-navigation__list-item');
            let $toggle = $listItem.children('.hierarchical-navigation__item-wrapper').find('.hierarchical-navigation__toggle');

            $toggle.attr('aria-expanded', 'false');
            $listItem.removeClass('expanded');
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/components/hierarchical-nav.js